import { cva } from "../../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { cn } from "../../../../lib/utils.js";
const tabsVariants = cva(
  "flex gap-2",
  {
    variants: {
      orientation: {
        horizontal: "flex-col",
        vertical: ""
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
), tabsListVariants = cva(
  "flex w-fit items-center",
  {
    variants: {
      orientation: {
        horizontal: "",
        vertical: "h-fit w-fit flex-col"
      },
      type: {
        card: "justify-center bg-(--gray-tag-2-alpha) rounded-md",
        line: "w-full border-b border-b-(--gray-tag-2-alpha)"
      }
    },
    defaultVariants: {
      orientation: "horizontal",
      type: "card"
    }
  }
), tabsTriggerVariants = cva(
  cn`
    relative flex items-center justify-center gap-1.5 h-full
    text-(--gray-text-2) font-medium whitespace-nowrap
    disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed 
    [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4
  `,
  {
    variants: {
      size: {
        sm: "px-3 py-0.5 text-sm",
        default: "px-4 py-1 text-base",
        lg: "px-6 py-1.5 text-lg"
      },
      divider: {
        default: "",
        divider: ""
      },
      orientation: {
        horizontal: "",
        vertical: "w-full"
      },
      type: {
        card: cn`
          flex-1 border border-transparent rounded-md transition-[background-color]
          focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring focus-visible:ring-[3px]
          data-[state=active]:bg-(--white) data-[state=active]:border-(--gray-border-1)
        `,
        line: cn`
           text-(--gray-text-1-alpha) before:absolute before:content-[''] before:bottom-[-1px]
           before:left-[50%] before:right-[50%] before:transition-[left,right]
           before:border-b before:border-b-[2px] before:border-b-(--primary-2)
           data-[state=active]:font-semibold data-[state=active]:text-(--gray-text-2)
           data-[state=active]:before:left-0 data-[state=active]:before:right-0 
        `
      }
    },
    compoundVariants: [
      {
        orientation: "horizontal",
        divider: "divider",
        type: "card",
        class: "before:top-1 before:bottom-1 before:left-0"
      },
      {
        orientation: "vertical",
        divider: "divider",
        type: "card",
        class: "before:left-1 before:right-1 before:top-0"
      },
      {
        divider: "divider",
        type: "card",
        class: "before:content-[''] before:absolute before:border before:border-(--gray-border-1) data-[state=active]:before:hidden"
      }
    ],
    defaultVariants: {
      size: "default",
      divider: "default",
      orientation: "horizontal",
      type: "card"
    }
  }
);
export {
  tabsListVariants,
  tabsTriggerVariants,
  tabsVariants
};
//# sourceMappingURL=variants.js.map
